export class Zona {
    
    public idcompania: string;
    public idZona: number;
    public descripcion: string;

}